// anniversary.js
import './bootstrap';

import { createApp, defineAsyncComponent } from 'vue';

import QuoteFormLoader from './components/QuoteFormLoader.vue';
import GoogleMapLazyLoader from './components/GoogleMapLazyLoader.vue';
import ConsentBanner from './components/ConsentBanner.vue';
import { loadPrimeVue } from '@/utils/loadPrimeVue.js'

const app = createApp({});

// Provide the loader via a global property or a prop wrapper
app.provide('QuoteFormLoader', () => import('./components/AnniversaryQuoteForm.vue'))
app.provide('GoogleMapLazyLoader', () => import('./components/GoogleMap.vue'))

app.component('quote-form-loader', QuoteFormLoader);
app.component('google-map-lazy-loader', GoogleMapLazyLoader);
app.component('consent-banner', ConsentBanner);

await loadPrimeVue(app)

app.mount('#app');